import React from 'react';
import { FontFamily, Input, PrimaryButton } from 'utils/imports.utils';
import { ButtonSize, ButtonTypes } from 'utils/interface.utils';
import { AccountPasswordTabProps } from 'interfaces/account_settings.interface';

const AccountPasswordTab: React.FC<AccountPasswordTabProps> = ({
  currentPassword,
  newPassword,
  confirmPassword,
  isDisabled,
  isSubmitting,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
}) => (
  <div className="account_settings_panel_change_password">
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}>
      <div className="account_settings_panel_change_password_form">
        <div className="account_settings_panel_change_password_form_input_container">
          <Input
            value={currentPassword}
            label="Current password"
            type="password"
            placeholder="Enter your current password"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onCurrentPasswordChange(e.target.value)}
          />
        </div>
        <div className="account_settings_panel_change_password_form_input_container">
          <Input
            value={newPassword}
            label="New password"
            type="password"
            placeholder="Enter your new password"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onNewPasswordChange(e.target.value)}
          />
        </div>
        <div className="account_settings_panel_change_password_form_input_container">
          <Input
            value={confirmPassword}
            label="Confirm password"
            type="password"
            placeholder="Enter your confirm password"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onConfirmPasswordChange(e.target.value)}
          />
        </div>
      </div>
      <div className="account_settings_panel_change_password_buttons_container">
        <div className="account_settings_panel_change_password_buttons_save">
          <PrimaryButton
            text="Change password"
            size={ButtonSize.MEDIUM}
            fontFamily={FontFamily.medium}
            lineHeight="20px"
            onClick={onSubmit}
            type={isDisabled ? ButtonTypes.DISABLED : ButtonTypes.PRIMARY_GRADIENT}
            disabled={isDisabled}
            activity={isSubmitting}
          />
        </div>
      </div>
    </form>
  </div>
);

export default AccountPasswordTab;
